export default "__VITE_ASSET__DKA$fsPu__"